import React from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import 'views/Analytics/AnalyticsScrollMenu/AnalyticsScrollMenu.css';
import { ScrollMenuItem } from 'views/Analytics/AnalyticsScrollMenu/AnalyticsScrollMenuItem';
import AnalyticsDropdown from 'views/Analytics/AnalyticsScrollMenu/AnalyticsDropdown/AnalyticsDropdown';
import {
  calculateAnalyticsDropDownOffset,
  calculateAnalyticsScrollBarMenuWidth,
} from 'views/Analytics/AnalyticsScrollMenu/ScrollMenuUtils';
import { AnalyticsTabItem } from 'store/analytics/ui/analyticsUiTypes';
import BzmIcon from 'components/icons/BzmIcon';
import MockServiceIcon from 'components/icons/MockServiceIcon';

// All items component
export const Menu = (tabs: AnalyticsTabItem[], selected: any, closeHandler: any, selectHandler: any) => {
  const menuItems: any[] = tabs.map((tabItem: AnalyticsTabItem) => {
    const { name, id } = tabItem;

    let icon = <BzmIcon color="#368fa8" variant={'icon-bzm-graph'} size={20}></BzmIcon>;

    if (tabItem.type === 'MOCK_SERVICE') {
      icon =
        tabItem.subType === 'SV' ? (
          <MockServiceIcon type={'SV'} size={18} />
        ) : (
          <MockServiceIcon type={'TRANSACTIONAL'} size={18} />
        );
    }

    return (
      <ScrollMenuItem
        id={id}
        icon={icon}
        title={name}
        key={id}
        selected={selected}
        closeHandler={closeHandler}
        selectHandler={selectHandler}
      />
    );
  });

  return menuItems;
};

const Arrow = ({ content, className }: any) => {
  return <div className={className}>{content}</div>;
};

const ArrowLeft = Arrow({ content: <BzmIcon variant="icon-bzm-chevron-left" />, className: 'arrow-prev' });
const ArrowRight = Arrow({ content: <BzmIcon variant="icon-bzm-chevron-right" />, className: 'arrow-next' });

type AnalyticsScrollMenuProps = {
  items: any;
  selected: any;
  closeTabHandler: any;
  selectTabHandler: any;
  disabled: boolean;
};

/**
 * Analytics scroll based on React Horizontal Scrollbar. The RHS supports originally only fixed width,
 * there was a need to implement browser like behaviour - the expansion of the whole scrollbar  is done manually
 * with ScrollMenuUtils.ts
 * @param props
 * @constructor
 */
const AnalyticsScrollMenu = (props: AnalyticsScrollMenuProps) => {
  const menuItems = Menu(props.items, props.selected, props.closeTabHandler, props.selectTabHandler);
  const menuWidth = calculateAnalyticsScrollBarMenuWidth(props.items);

  return (
    <>
      <div className="d-flex align-items-start">
        {/* Tabs content */}
        {menuItems.length > 0 ? (
          <div
            id="analytics-scroll-menu"
            style={{ width: calculateAnalyticsScrollBarMenuWidth(props.items) + 'px', maxWidth: '95%' }}
          >
            <ScrollMenu
              alignCenter={false}
              inertiaScrolling={true}
              menuStyle={{
                height: '35px',
              }}
              data={menuItems}
              arrowLeft={ArrowLeft}
              arrowRight={ArrowRight}
              hideArrows={true}
              selected={props.selected}
              onSelect={props.selectTabHandler}
              scrollToSelected={true}
              useButtonRole={false}
            />
          </div>
        ) : (
          <div className="ml-2"></div>
        )}
        {/* ./Tabs content */}

        {/* DropDown with list of Virtual Services */}
        <AnalyticsDropdown
          // Dropdown menu cut off resolution, use right positon for opening menu when size of the menu
          dropDownPlacement={menuWidth > 900 ? 'RIGHT' : 'LEFT'}
          leftOffset={props.items.length !== 0 ? calculateAnalyticsDropDownOffset(menuWidth) : 15}
          disabled={props.disabled}
        />
        {/* ./ DropDown with list of Virtual Services */}
      </div>
    </>
  );
};

export default AnalyticsScrollMenu;
